import { render, staticRenderFns } from "./ProviderSuccess.vue?vue&type=template&id=3796f789"
import script from "./ProviderSuccess.vue?vue&type=script&lang=js"
export * from "./ProviderSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports